import { Col } from "react-grid-system";
import styled from "styled-components";

export const StyledDecisionBody = styled(Col)`
	margin-top: 1.6rem;
	margin-bottom: 1.6rem;
`;
